// Inventory-conflict modal 用的 enum labels（holder_type / source_type）。
// 兩個 enum 都是 BE 寫死值域（見 InventoryConflictResolver / Fulfillment#source_type），
// FE 完全掌握 → 表列為 hook，禁止 t(`...${var}`) 動態 key。
import { useTranslation } from 'react-i18next';

import type { FulfillmentSourceType, HolderType } from '@services/inventoryConflictSchemas';

export function useHolderTypeLabel() {
  const { t } = useTranslation();
  return (holderType: string | null | undefined): string => {
    if (!holderType) return '';
    switch (holderType as HolderType) {
      case 'fulfillment':    return t('shared.inventory_conflict.holder_type.fulfillment');
      case 'inventory_hold': return t('shared.inventory_conflict.holder_type.inventory_hold');
      default:               return holderType;
    }
  };
}

export function useFulfillmentSourceTypeLabel() {
  const { t } = useTranslation();
  return (sourceType: string | null | undefined): string => {
    if (!sourceType) return '';
    switch (sourceType as FulfillmentSourceType) {
      case 'order':                return t('shared.inventory_conflict.source_type.order');
      case 'work_order':           return t('shared.inventory_conflict.source_type.work_order');
      case 'stock_transfer_order': return t('shared.inventory_conflict.source_type.stock_transfer_order');
      default:                     return sourceType;
    }
  };
}
